import { FormOutlined } from '@ant-design/icons'
import styled from '@emotion/styled'

export const StyledFormOutlined = styled(FormOutlined)`
  font-size: 30px;
  padding-left: 15px;
`
